import { BrowserRouter } from 'react-router';
import { AppShell } from './AppShell';

export function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
